import { render, staticRenderFns } from "./RiskSelectionSlider.vue?vue&type=template&id=7efef036&scoped=true"
import script from "./RiskSelectionSlider.vue?vue&type=script&lang=ts&setup=true"
export * from "./RiskSelectionSlider.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./RiskSelectionSlider.vue?vue&type=style&index=0&id=7efef036&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efef036",
  null
  
)

export default component.exports